import { useEffect } from "react";
import IconCustomer from "../SvgIcon/IconCustomer";

export default function CustomerDetailsModal({ show, onClose, customer, loading }) {
    console.log("Customer Modal", customer);

    useEffect(() => {
        document.body.classList.toggle("modal-open", show);

        return () => {
            document.body.classList.remove("modal-open");
        };
    }, [show]);

    if (!show) return null;
    const BASE_URL = "https://api.tgstl.net";
    // console.log("BASE_URL", BASE_URL);
    return (
        <>
            {/* Backdrop */}
            <div className="modal-backdrop fade show"></div>

            {/* Modal */}
            <div
                className="modal fade show d-block"
                tabIndex="-1"
                role="dialog"
            >
                <div className="modal-dialog modal-xl modal-responsive modal-dialog-centered">
                    <div className="modal-content">

                        {/* Header */}
                        <div className="modal-header">
                            <h6 className="modal-title d-flex align-items-center gap-2"><IconCustomer /> <strong>Party Name:</strong> {customer?.CustomerName || "-"}</h6>
                            <button type="button" className="btn-close" onClick={onClose} />
                        </div>

                        {/* Body */}
                        <div className="modal-body party-modal">
                            {loading ? (
                                <div className="text-center p-4">
                                    <div className="spinner-border text-primary" role="status" />
                                    <p className="mt-2">Loading details...</p>
                                </div>
                            ) : (
                                <div className="customer-info-box">
                                    <ul className="visitinfo">
                                        <li>
                                            <span>Visited Date:</span>{" "}
                                            {customer?.created_at
                                                ? new Date(customer.created_at).toLocaleDateString("en-IN", {
                                                    day: "2-digit",
                                                    month: "short",
                                                    year: "numeric",
                                                })
                                                : "-"}
                                        </li>
                                        <li>
                                            <span>Party Business:</span> {customer?.CustomerBusiness || "-"}
                                        </li>
                                        {customer?.CustomerProject && (
                                            <li>
                                                <span>Customer Project:</span> {customer?.CustomerProject || "-"}
                                            </li>
                                        )}

                                        <li>
                                            <span>Contact Person:</span> {customer?.ContactPerson || "-"}
                                        </li>


                                        {/* <li>
                                            <span>Existing Party:</span> {customer?.ExistingParty || "-"}
                                        </li> */}

                                        {/* <li>
                                            <span>Whom to Visit:</span> {customer?.WhomtoVisit || "-"}
                                        </li> */}

                                        <li>
                                            <span>Email:</span> {customer?.Email || "-"}
                                        </li>
                                        <li>
                                            <span>Mobile No:</span> {customer?.Mobile || "-"}
                                        </li>
                                        <li>
                                            <span>Address:</span> {customer?.Address || "-"}
                                        </li>
                                        <li>
                                            <span>Area:</span> {customer?.Area || "-"}
                                        </li>
                                        {customer?.Pincode && (
                                            <li>
                                                <span>Pincode:</span> {customer?.PinCode || "-"}
                                            </li>
                                        )}
                                        <li>
                                            <span>Country:</span> {customer?.Country || "-"}
                                        </li>
                                        <li>
                                            <span>Is Tally User?:</span>{" "}
                                            {customer?.TallySerialNo ? "Yes" : "No"}
                                        </li>
                                        <li>
                                            <span>Tally Serial No:</span> {customer?.TallySerialNo || "-"}
                                        </li>

                                        <li>
                                            <span>Tss Expiry Date:</span> {customer?.TSSExpiryDate || "-"}
                                        </li>
                                        <li>
                                            <span>Visiting Purpose:</span> {customer?.SalesList || "-"}
                                        </li>

                                        <li>
                                            <span>Remarks:</span> {customer?.Remark || "-"}
                                        </li>

                                        <li>
                                            <span>Next Visit Date:</span> {customer?.NextVisitShedule || "-"}
                                        </li>
                                        <li>
                                            <span>Next Visit Time:</span> {customer?.NextSheduleTime || "-"}
                                        </li>
                                        <li>
                                            <span>Person To Look For Next Visit:</span> {customer?.PersonForNextVisit || "-"}
                                        </li>
                                        <li>
                                            <span>Current Location:</span> {customer?.CurrentLocation || "-"}
                                        </li>
                                    </ul>
                                    {/* Image */}
                                    <ul className="user-address-img">
                                        {[
                                            {
                                                label: "Visiting Card",
                                                src: customer?.CustomerVisitingCardImage
                                            },
                                            {
                                                label: "Client Location",
                                                src: customer?.ClientLocationImage
                                            },
                                            {
                                                label: "User Image",
                                                src: customer?.UserPhoto
                                            },
                                            {
                                                label: "User Signature",
                                                src: customer?.UserSigniture
                                            }
                                        ].map((item, index) => (
                                            <li key={index}>
                                                <span>{item.label}</span>
                                                
                                                <img src={item.src ? `${BASE_URL}${item.src}` : "https://t4.ftcdn.net/jpg/01/30/22/71/360_F_130227142_UnP3uAs9J30B0ORkBpG3apv8UC0nlJ65.jpg"} alt={item.label} style={{ width: "100%", height: "250px" }} />
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}

                        </div>

                        {/* Footer */}
                        {/* <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={onClose}>
                                Close
                            </button>
                        </div> */}

                    </div>
                </div>
            </div>
        </>
    );
}